<template>
  <div>
  <div class="form_section">
    <div class="form_container">
      <ValidationObserver v-slot="{ handleSubmit}" ref="form">
        <form @submit.prevent="handleSubmit(sendForm)" novalidate >
        <h2 class="form_title textT2 ">
          מלאו את הפרטים הבאים:
        </h2>
        <div class="form_wrap">


          <div class="line_wraper type2">
            <div class="form_item">
              <ValidationProvider :rules="{ required:true,min: 2 }" v-slot="{ errors }" vid="firstName" name="שם פרטי">
                <div class="form_input">
                  <label for="firstName" class="visuallyhidden">שם פרטי: </label>
                  <input type="text" name="firstName" id="firstName" placeholder="שם פרטי:" v-model="form.firstName" :class="{error:errors.length>0}"/>
                  <span class="error_msg textT3">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <div class="form_item">
              <ValidationProvider :rules="{ required:true,min: 2 }" v-slot="{ errors }" vid="lastName" name="שם משפחה">
                <div class="form_input">
                  <label for="lastName" class="visuallyhidden">שם משפחה: </label>
                  <input type="text" name="lastName" id="lastName" placeholder="שם משפחה:" v-model="form.lastName" :class="{error:errors.length>0}"/>
                  <span class="error_msg textT3">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>

          </div>





          <div class="line_wraper type2">
            <div class="form_item">
              <ValidationProvider rules="required|numeric|min:9|max:10" v-slot="{ errors }" vid="phone" name="טלפון נייד">
              <div class="form_input">
                <label for="phone" class="visuallyhidden">טלפון נייד: </label>
                <input type="tel" name="phone" id="phone" v-model="form.phone" placeholder="טלפון נייד: " maxlength="10"/>
                <span class="error_msg textT3">{{ errors[0] }}</span>
              </div>
              </ValidationProvider>
            </div>

            <div class="form_item">
              <ValidationProvider rules="required|email" v-slot="{ errors }" vid="email" name="מייל">
                <div class="form_input">
                  <label for="email" class="visuallyhidden">מייל: </label>
                  <input type="text" name="email" id="email" placeholder="מייל:" v-model="form.email" :class="{error:errors.length>0}"/>
                  <span class="error_msg textT3">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>

          </div>







          <div class="line_wraper type2">
            <div class="form_item">
              <ValidationProvider rules="required" v-slot="{ errors }" vid="member" name='חבר.ת מכבי'>
                <div class="form_input">
                  <label for="member" class="visuallyhidden">האם הינך חבר.ת מכבי? </label>
                  <select name="member" v-model="form.member" id="member">
                    <option value="">האם הינך חבר.ת מכבי? </option>
                    <option value="כן">כן</option>
                    <option value="לא">לא</option>
                  </select>
                  <div class="icon"><img src="../assets/img/arrow.png" alt="חץ למטה"/></div>
                  <span class="error_msg textT3">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <div class="form_item">
              <div class="form_checkbox textT3 color2">
                <ValidationProvider  rules="checkboxRule" v-slot="{ errors }" vid="accept" name="דיוור">
                  <label class="checkbox_wrap">
                    <input type="checkbox" name="accept" id="accept" v-model="form.accept"><span class="checkmark"></span><span><p>אני מאשר.ת לקבל בהודעת מייל אלקטרונית ו/או ב-SMS עדכונים, מידע פרסומי ודיוור שיווקי לרבות מידע על מבצעים ומחירים המתעדכנים של מכבי פארם ומכבי שירותי בריאות</p></span>
                  </label>
                  <span class="error_msg textT3">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>





          <div class="form_btn"><button type="submit" class="btnT1 back3 color1 textT2" aria-label="לחץ לשליחת טופס" >שליחה </button> </div>
          <div class="small_text centerText textT4">השירות לחברי מכבי בלבד</div>
        </div>

        <transition name="fade">
        <div class="msg_send centerText back1" v-show="submitStatus === 'OK'">
          <div class="msg_send_wraper" v-if="form.member == 'כן'">
            <p class="textT2 boldType">תודה! הרשמתך התקבלה.</p>
          </div>
          <div class="msg_send_wraper" v-if="form.member == 'לא'">
            <p class="textT2 margB1">
              תודה שנרשמת,<br>
              <strong class="boldType">השירות רק לחברי מכבי.</strong>
            </p>
            <div class=" flex-center">
            <a class="btnT1 back3 color1 widthAuto boldType textT5" href="https://www.maccabi4u.co.il/new/landing/joinmaccabi_a" target="_blank">להצטרפות למכבי שירותי בריאות ></a>
            </div>
            </div>
        </div>
        </transition>
      </form>
      </ValidationObserver>
    </div>
  </div>
  </div>
</template>

<script>

import { ValidationObserver, ValidationProvider, extend ,localize } from 'vee-validate';
import { required, email ,numeric ,min ,max,digits,regex } from 'vee-validate/dist/rules';
extend('email', email);
extend('required', required);
extend('numeric', numeric);
extend('min', min);
extend('max', max);
extend('digits', digits);
extend('regex', regex);
import he from 'vee-validate/dist/locale/he.json';
// import AutoComplete from "./autoComplete";
import {formService} from "../../service/form.service";
localize('he', he);
extend('ils_id',{
  message: field => 'שדה ' + field + ' לא תקין',
  validate: (value) => { return ValidateID(value);}
});
extend('ageRule',{
  message: field => 'שדה ' + field + ' לא תקין',
  validate: (value) => { return ((value > 120) ||  (value < 1) ? false : true)},
});
extend('checkboxRule',{
  message:'שדה חובה',
  validate: (value) => { return value;}
});
extend('radioRule',{
  message:'שדה חובה',
  validate: (value) => { return {required: true,valid: ['', null, undefined].indexOf(value) === -1}},
  computesRequired: true
});



function ValidateID(str) {
  let IDnum = String(str);
  // Validate correct input
  if (isNaN(IDnum) || (IDnum.length > 9) || (IDnum.length < 9) || (IDnum === '000000000'))
    return false;
  // The number is too short - add leading 0000
  if (IDnum.length < 9)
  {
    while(IDnum.length < 9)
    {
      IDnum = '0' + IDnum;
    }
  }
  // CHECK THE ID NUMBER
  let mone = 0, incNum;
  for (let i=0; i < 9; i++)
  {
    incNum = Number(IDnum.charAt(i));
    incNum *= (i%2)+1;
    if (incNum > 9)
      incNum -= 9;
    mone += incNum;
  }
  if (mone%10 == 0)
    return true;
  else
    return false;
}

export default {
  name: "formApp",
  // components: {AutoComplete, ValidationProvider,ValidationObserver },
  components: { ValidationProvider,ValidationObserver },
  data(){
    return{
      form:{
        firstName:'',
        lastName:'',
        phone:'',
        email:'',
        member:'',
        accept:false,
        utm_source:''
      },
      // phoneTemp:{
      //   code:'',
      //   number:''
      // },
      // codesData:['050','051','052','053','054','055','057','058'],
      openForm:false,
      submitStatus: false,
      // citiesData:null

    }
  },

  created() {
    // this.phoneTemp.code = this.codesData[0];
    // this.loadCities();
    this.getUrlParams();
  },
  methods:{
    getUrlParams(){
      let utm_source = new URL(location.href).searchParams.get('utm_source');
      utm_source ? this.form.utm_source = utm_source : '';

    },
    // async loadCities() {
    //   const cities = await formService.loadCities();
    //   this.citiesData = cities.cities;
    //   // this.citiesData = [
    //   //   {code:'123',city_name:'בת ים'},
    //   //   {code:'124',city_name:'חולון'},
    //   //   {code:'125',city_name:'ירושלים'},
    //   //   {code:'126',city_name:'יהוד'},
    //   //   {code:'127',city_name:'תל אביב'},
    //   //   {code:'128',city_name:'חיפה'}
    //   // ]
    // },
    gtagSend(){
      window.gtag('event', 'click', {'event_category': 'button', 'event_label': 'link'});
    },
    async sendForm(){
      //console.log('send')
      this.submitStatus = 'PENDING';
      // this.form.phone2 = this.phoneTemp.code + this.phoneTemp.number;
      // console.log('formData',JSON.stringify(this.form));

      let formData = new FormData();
      formData.append("lead", JSON.stringify(this.form));


      let leadResult = await formService.saveLead(formData);

      if (leadResult.status === '1') {
        this.submitStatus = 'OK';
        window.dataLayer.push({
          'event': 'lead_submit'
        });
        // window.gtag('event', 'click', {'event_category': 'button', 'event_label': 'lead_submit'});
      } else {
        let myObj = new Object();
        myObj[leadResult.field]=[leadResult.message];
        this.$refs.form.setErrors(myObj);
        // this.$refs.form.setErrors({
        //   fullName: ['error name'],
        //   city:['error city'],
        // });
        this.submitStatus = 'ERROR';
      }



    },
  },

}
</script>

<style  lang="scss">



.visuallyhidden{
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.form_section{


}
.form_container{
  position: relative;
}
.form_title{
  margin-bottom: 23px;
  @include breakpoint('point1'){margin-bottom: vw-d(23);}
  @include breakpoint('mobile'){
    margin-bottom: vw-m(25);
  }
}
.line_wraper{
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  //margin-bottom: 20px;
  width: 100%;
  //@include breakpoint('point1'){margin-bottom: vw-d(20);}
  //@include breakpoint('mobile'){
  //
  //  margin-bottom: 0;
  //}
  &.type2{
    .form_item{
      width: 48.6%;
      @include breakpoint('mobile'){width: 100%;}
    }
  }


}
.form_item{
  width: 100%;
  margin-bottom: 20px;
  @include breakpoint('point1'){margin-bottom: vw-d(20);}
  >span{display: block; width: 100%;}
  @include breakpoint('mobile'){margin-bottom: vw-m(15);}
}

.form_wrap {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;

  @include breakpoint('mobile'){
    >span{width: 100%;}
  }
}

.form_input {
  position: relative;

  input:not([type='radio']),select,textarea{
    text-align: right;
    direction: rtl;
    background: $color2;
    color:$color1;
    width: 100%;
    //height: 50px;
    border-radius: 6px;
    border: none;
    padding: 5px 14px;
    font-size: 100%;
    position: relative;
    @include breakpoint('point1'){
      border-radius: vw-d(6);
      //height: vw-d(50);
      padding: vw-d(5) vw-d(14);
    }
    @include breakpoint('mobile'){
      //height: vw-m(46);
      border-radius: vw-m(4);
      padding: vw-m(9) vw-m(10);
    }
  }
  input[type='radio']{
    margin-top: 0;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus
  {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: $color1 !important;
    border: none;
    -webkit-box-shadow: none;
    background-color: $color2!important;
  }
  input,textarea{
    &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
      color: $color1;
    }
    &::-moz-placeholder { /* Firefox 19+ */
      color: $color1;
    }
    &:-ms-input-placeholder { /* IE 10+ */
      color: $color1;
    }
    &:-moz-placeholder { /* Firefox 18- */
      color: $color1;
    }
  }
  select{
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';
    &::-ms-expand {
      display: none;
    }
  }
  .icon{
    position: absolute;
    left: 10px;
    width: 17px;
    top: 7px;
    pointer-events: none;
    @include breakpoint('point1'){
      left: vw-d(10);
      width: vw-d(17);
      top: vw-d(7);
    }
    @include breakpoint('mobile'){
      left: vw-m(13);
      width: vw-m(15);
      top: vw-m(10);
    }
  }
  .open{position: relative;}
  label{
    color: #ffffff;
  }
}
.error_msg {
  //position: absolute;
  color: red;
  display: block;
  width: 100%;
  font-family: 'Arial';
  //top: calc(100% + 5px);
  //right: 0;
  //font-size: 85%;
  //@include breakpoint('point1'){
  //  top: calc(100% + 0.37vw);
  //}
  margin-top: 5px;
  @include breakpoint('point1'){
    margin-top: vw-d(6);
  }
}
.form_btn {
  margin: 50px auto 0;
  //width: 100%;
  @include breakpoint('point1'){margin-top:vw-d(50);}
  @include breakpoint('mobile'){
    width: 100%;
    //order: 1;
    margin-top: vw-m(12);
  }
}
.btnT1 {
  width: 100%;
font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 91px;
  min-width: 424px;
  padding: 19px;
  @include breakpoint('point1'){
    border-radius: vw-d(91);
    min-width: vw-d(424);
    padding: vw-d(19);
  }
  @include breakpoint('mobile'){
min-width: auto;
    border-radius: vw-m(91);
    padding: vw-m(12);
  }
}
.btnT2 {
  width: 100%;
  background: $mainColor;
  color: #ffffff;
  padding: 15px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 166.66%;
  font-family: inherit;
  font-weight: 400;
  @include breakpoint('point1'){
    padding: vw-d(15) vw-d(10);
    border-radius: vw-d(12);
  }
  @include breakpoint('mobile'){
    font-size: 114.28%;
    padding: vw-m(13) vw-m(10);
    border-radius: vw-m(9);
  }
}

.form_checkbox {
  position: relative;
  font-family: 'Arial';
  .error_msg {
    font-size:100%;
    position: absolute;
    top: 90%;
    right: 0;
    //@include breakpoint('point1'){
    //  top: calc(100% + 0.37vw);
    //}
    @include breakpoint('mobile'){
      top: 100%;
      //font-size: 94.44%;
    }
  }
}
.checkbox_wrap {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  position: relative;
  padding-right: 45px;
  cursor: pointer;
  user-select: none;
  //min-height: 23px;
  @include breakpoint('point1'){
    padding-right: vw-d(45);
    //min-height:vw-d(23);
  }
  @include breakpoint('mobile'){
    padding-right: vw-m(39);
    //min-height: vw-m(23);
  }
  input {
    -webkit-appearance: none;
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 100%;
    left: 0;
    margin: 0;
    right: 0;
    top: 0;
    &:checked ~ .checkmark::after {
      display: block;
    }
  }

  .checkmark {
    position: absolute;
    top: 0;
    right: 0;
    width: 31px;
    height: 31px;
    background-color: $color2;
    pointer-events: none;
    border-radius: 3px;
    border: none;
    @include breakpoint('point1'){
      border-radius: vw-d(3);
      width: vw-d(31);
      height: vw-d(31);
    }
    @include breakpoint('mobile'){
      border-radius: vw-m(3);
      width: vw-m(28);
      height: vw-m(28);
    }
    &::after{
      content: "";
      position: absolute;
      display: none;
      left: 10px;
      top: 3px;
      width: 7px;
      height: 17px;
      border: solid $color1;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
      @include breakpoint('point1'){
        left: vw-d(10);
        top:vw-d(3);
        width: vw-d(7);
        height: vw-d(17);
        border-width: 0 vw-d(3) vw-d(3) 0;
      }
      @include breakpoint('mobile'){
        left: vw-m(10);
        top:vw-m(3);
        width: vw-m(6);
        height: vw-m(14);
        border-width: 0 vw-m(3) vw-m(3) 0;
      }
    }
  }
}
.msg_send{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: $color1;

}
.msg_send_wraper {
  width: 100%;
  .btn{
    margin-top: 37px;
    @include breakpoint('point1'){
      margin-top: vw-d(37);
    }
    @include breakpoint('mobile'){
      margin-top: vw-m(32);
    }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.small_text{
  width: 100%;
  margin-top:26px;
  @include breakpoint('point1'){
    margin-top: vw-d(26);
  }
  @include breakpoint('mobile'){
    margin-top: vw-m(17);
  }
}


</style>